import { Component, OnInit, ElementRef, } from '@angular/core'
import {environment} from '../../../environments/environment'
import {HttpClient, HttpHeaders} from '@angular/common/http'
// import { Response } from "@angular/http" // Deprecated - using HttpClient now
import Swal from 'sweetalert2';
import{map} from "rxjs/operators";
import { User } from '../../../app/_models';
import { UserService } from '../../_services';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { LogoComponent } from '../../_shared/logo/logo.component';
import { PasswordInputComponent } from '../../_shared/password-input/password-input.component';
import { PasswordStrengthChecklistComponent } from '../../_shared/password-strength-checklist/password-strength-checklist.component';
import { getPasswordStrengthFlags, PasswordStrengthFlags } from '../../_shared/validators/password-strength.validator';
import { AUTH_ERROR_CODES, AUTH_ERROR_MESSAGES } from '../../_shared/auth-error-codes';
import { KtidentityService } from '../../_services/ktidentity.service';

interface RecoveryAlertConfig {
  icon: 'error' | 'warning' | 'info' | 'success';
  titleKey: string;
  textKey?: string;
}

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, TranslateModule, LogoComponent, PasswordInputComponent, PasswordStrengthChecklistComponent],
  selector: 'app-recovery',
  templateUrl: './recovery.component.html',
  styleUrls: ['./recovery.component.scss']
})
export class RecoveryComponent implements OnInit {
  public user: User | undefined;
  isValid = false;
  returnUrl: string = '';
  passwordFlags: PasswordStrengthFlags = getPasswordStrengthFlags('');
  // ?provider=ktidentity: a redefinição é feita pelo Identity, que envia o link por e-mail
  ktidentityMode = false;
  ktidentityReason: 'locked' | 'expired' | '' = '';
  ktidentitySent = false;

  // Mapa único de mensagens de erro do backend -> {icon, título, texto}, no mesmo
  // padrão usado na tela de login (Fase 2), em vez de exibir o código bruto do backend.
  private readonly forgotPasswordErrorAlerts: Record<string, RecoveryAlertConfig> = {
    [AUTH_ERROR_CODES.USER_NOT_FOUND]: { icon: 'error', titleKey: 'PAGES.invalidEmail' }
  };

  private readonly confirmPasswordErrorAlerts: Record<string, RecoveryAlertConfig> = {
    [AUTH_ERROR_CODES.CODE_MISMATCH]: { icon: 'error', titleKey: 'PAGES.invalidVerificationCode' }
  };

  private readonly defaultAlert: RecoveryAlertConfig = {
    icon: 'error',
    titleKey: 'LOGIN.thereWasAProblem'
  };

  constructor(
    private http:HttpClient,
    private route: ActivatedRoute,
    private router: Router,
    private userService: UserService,
    public translate: TranslateService,
    private ktidentityService: KtidentityService
    ) {

      this.user = new User();

    // this.email = new FormControl('',[Validators.required,Validators.minLength(8)]);
    // this.code = new FormControl('',[Validators.required]);
    // this.password = new FormControl('',[Validators.required,Validators.minLength(8)])
    // this.regForm = formBuilder.group({
    //   email: this.email,
    //   code: this.code,
    //   password: this.password
    // })


  }

  ngOnInit() {
    document.body.className = 'hold-transition login-page';
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/login';

    const params = this.route.snapshot.queryParams;
    if (params['provider'] === 'ktidentity') {
      this.ktidentityMode = true;
      this.ktidentityReason = params['reason'] === 'locked' || params['reason'] === 'expired' ? params['reason'] : '';
      if (this.user && typeof params['email'] === 'string') {
        this.user.email = params['email'];
      }
      if (params['auto'] === '1' && this.user?.email) {
        this.submitKtidentityRecovery();
      }
    }
  }

  submitKtidentityRecovery() {
    this.ktidentityService.forgotPassword(this.user?.email || '').subscribe(() => {
        this.ktidentitySent = true;
      },
      () => this.showAlert(this.defaultAlert)
    );
  }

  onPasswordChange(value: string) {
    this.passwordFlags = getPasswordStrengthFlags(value);
  }
  submitRecovery(){
    if (this.ktidentityMode) {
      this.submitKtidentityRecovery();
      return;
    }
    this.userService.forgot_password(this.user?.email || '').subscribe((data: any) => {
        if (data?.code === 'ktidentity_account') {
          // conta migrada para o KTIdentity: a redefinição é feita pelo Identity
          this.ktidentityMode = true;
          this.submitKtidentityRecovery();
        } else if(data.message == AUTH_ERROR_MESSAGES.USER_NOT_STARTED) {
          this.showAlert({ icon: 'info', titleKey: 'PAGES.userNotStarted', textKey: 'PAGES.useTemporaryPasswordForAccess' });
          this.router.navigate([this.returnUrl]);

        }else{
          this.showAlert({ icon: 'success', titleKey: 'PAGES.recoveryEmailSentSuccessfully' });
          this.isValid =true
        }
      },
      (error: any) => {
        const code = error?.error?.code;
        this.showAlert((code && this.forgotPasswordErrorAlerts[code]) || this.defaultAlert);
        this.isValid =false
      }
    );
  }

  

   changePassword(){
     let user = this.user?.email || '';
     let code = this.user?.code || '';
     let newPass = this.user?.password || '';
     this.userService.confirm_password(user,code,newPass).subscribe((data: any) => {
          this.showAlert({ icon: 'success', titleKey: 'PAGES.passwordChangedRedirectingToLogin' });
          this.router.navigate([this.returnUrl]);
       },
       (error:any) => {
         const code = error?.error?.code;
         this.showAlert((code && this.confirmPasswordErrorAlerts[code]) || this.defaultAlert);
        });
      }

  private showAlert(config: RecoveryAlertConfig) {
    Swal.fire({
      title: this.translate.instant(config.titleKey),
      text: config.textKey ? this.translate.instant(config.textKey) : undefined,
      icon: config.icon,
      showCancelButton: false,
      cancelButtonText: this.translate.instant('LOGIN.close'),
    });
  }

}
